import { ExploreContentApi_ContentType } from '~src/spacesPlatform/models/IContent';

import { CatalogContentType } from '../../catalog/CatalogContentType';
import { ExplorableItemType } from '../models/ContentType';

export const SITE_SPACE_EXPLORE = 'explore';
export type SiteSpaceContentType = ExploreContentApi_ContentType | CatalogContentType | 'explore';

export function convertSiteContentTypeToContentType(siteContentType: SiteSpaceContentType): ExplorableItemType {
  switch (siteContentType) {
    case SITE_SPACE_EXPLORE:
      return 'project';
    default:
      return siteContentType;
  }
}
